import { render, staticRenderFns } from "./AdditionalInformationForm.vue?vue&type=template&id=bd7eeb6a&lang=pug"
import script from "./AdditionalInformationForm.vue?vue&type=script&lang=js"
export * from "./AdditionalInformationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports